var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag",class:[_vm.optionClass, {'square': _vm.square}],style:({'background': _vm.background, 'font-weight': _vm.bold})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }